import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../locale/useTranslation';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import ToastNotification from "../../components/ToastNotification";
import { TOAST_TYPES } from "../../framework/constant/constant";

const InstanceLoginForm = (props) => {
    const lang = useTranslation();
    const { instances = [], cancelClick, okClick, isDigitalSignage = false, labelStyle = {} } = props;

    const [instanceData, setInstanceData] = useState([]);
    const [selectedInstance, setSelectedInstance] = useState(null);

    useEffect(() => {
        // Filter instances to only show active ones (default to false if IsActive not present)
        const activeInstances = instances.filter(instance => instance.IsActive !== false);
        setInstanceData(activeInstances);
        if (activeInstances?.length > 0) {
            setSelectedInstance(activeInstances[0]);
        } else {
            setSelectedInstance(null);
        }
    }, [instances]);

    const onOkClick = () => {
        if (!selectedInstance || Object.keys(selectedInstance).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_instance_error_message });
            return;
        }
        okClick(selectedInstance);
    };

    const onCancelClick = () => {
        setSelectedInstance(null);
        setInstanceData([]);
        cancelClick();
    };

    return (
        <div>
            <div className="mt-2">
                <label style={labelStyle} className="label ml-2">{lang.instance_label}</label>
                {instanceData.length > 0 ? (
                    <DropDownList
                        data={instanceData}
                        textField="Name"
                        dataItemKey="_id"
                        style={{ width: isDigitalSignage ? '100%' : '96%', padding: isDigitalSignage && "3px" }}
                        value={selectedInstance}
                        onChange={(e) => setSelectedInstance(e.target.value)}
                    />
                ) : (
                    <div className="alert alert-warning mt-2" role="alert">
                        There are no active instances available. You can't login.
                    </div>
                )}
            </div>
            <footer style={{ marginTop: isDigitalSignage ? '50px' : '130px' }}>
                <button 
                    type="button" 
                    className={`btn btn-primary ${isDigitalSignage && "mr-2"}`} 
                    onClick={onOkClick}
                    disabled={instanceData.length === 0}
                >
                    {lang.ok_label}
                </button>
                <button type="button" className="btn btn-danger" onClick={onCancelClick}>
                    {lang.cancel_label}
                </button>
            </footer>
        </div>
    );
};

export default InstanceLoginForm;